import React from "react";
import { Route, Routes } from "react-router-dom";
import { UserAuthsPage } from "components/pages/UserAuths/UserAuthsPage";
import { NewUserAuthPage } from "components/pages/UserAuths/NewUserAuthPage";
import { EditUserAuthPage } from "components/pages/UserAuths/EditUserAuthPage";
import { SearchUserAuthsPage } from "components/pages/UserAuths/SearchUserAuthsPage";

export default function UserAuthRoutes() {
  return (
    <Routes>
      <Route path="search" element={<SearchUserAuthsPage />} />
      <Route path="new" element={<NewUserAuthPage />} />
      <Route path=":id/edit" element={<EditUserAuthPage />} />
      <Route path="" element={<UserAuthsPage />} />
    </Routes>
  );
}
